import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Callback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
  let isProcessed = false;
  
  const handleCallback = async () => {
    if (isProcessed) return;
    isProcessed = true;
    
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    
    if (!code) {
      setError('Не получен код авторизации');
      return;
    }
    
    console.log('Processing code (first time):', code.substring(0, 20) + '...');
    
    try {
      const response = await fetch('/api/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          code,
          redirect_uri: window.location.origin + '/callback',
        }),
      });
      
      const data = await response.json();
      
      if (response.ok && data.access_token) {
        localStorage.setItem('access_token', data.access_token);
        navigate('/');
      } else {
        setError(data.error_description || 'Ошибка получения токена');
      }
    } catch (err) {
      setError('Сетевая ошибка: ' + err.message);
    }
  };
  
  handleCallback();
}, [navigate]);

  if (error) return <div style={{ color: 'red' }}>Ошибка: {error}</div>;
  return <div>Загрузка, получение токена...</div>;
};

export default Callback;